import tagId from '~/constants/common/TagId';
import { useFacetData } from '~/context/common/FacetDataContext';

export default function useHasPriceDropFacetCount(): boolean {
  const facetData = useFacetData();
  const priceDropFacet = facetData?.waysToSave?.tagIds?.buckets.find(
    tag => tag.key === tagId.PriceDrop.toString()
  );

  return Boolean(priceDropFacet && priceDropFacet.count > 0);
}
